"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcTimeline = function ArcTimeline(_ref) {
  var timelines = _ref.timelines,
    pending = _ref.pending,
    reverse = _ref.reverse,
    mode = _ref.mode;
  return /*#__PURE__*/_react["default"].createElement(_lib.Timeline, {
    pending: pending,
    reverse: reverse,
    mode: mode
  }, (timelines === null || timelines === void 0 ? void 0 : timelines.length) > 0 && timelines.map(function (timeline) {
    return /*#__PURE__*/_react["default"].createElement(_lib.Timeline.Item, {
      color: timeline === null || timeline === void 0 ? void 0 : timeline.color,
      dot: (timeline === null || timeline === void 0 ? void 0 : timeline.icon) && /*#__PURE__*/_react["default"].createElement("img", {
        src: timeline === null || timeline === void 0 ? void 0 : timeline.icon,
        style: {
          width: "20px"
        }
      })
    }, timeline.label);
  }));
};
var _default = ArcTimeline;
exports["default"] = _default;